import { faDesktop, faMobile, faQuestion, faUserFriends, IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { Enum, EnumType } from 'ts-jenum';

@Enum<SessionTypeEnum>('value')
export class SessionTypeEnum extends EnumType<SessionTypeEnum>() {
   static readonly UNKNOWN = new SessionTypeEnum('UNKNOWN', faQuestion, 'common.system_monitoring.session_type.unknown', null, 4);
   static readonly WEB_AGENT = new SessionTypeEnum('samwin.WebAgent', faDesktop, 'common.system_monitoring.session_type.wa', '#FD4E75', 1);
   static readonly MOBILE_AGENT = new SessionTypeEnum('samwin.MobileAgent', faMobile, 'common.system_monitoring.session_type.ma', '#4DCCBD', 2);
   static readonly TEAMS_INTEGRATION = new SessionTypeEnum('samwin.TeamsIntegration', faUserFriends, 'common.system_monitoring.session_type.ti', '#7B83EB', 3);

   private constructor(public value: string, public icon: IconDefinition, public nameTranslationKey: string, public color: string, public sortOrder: number) {
      super();
   }

   public static tryValueOf(value: string): SessionTypeEnum {
      try {
         return SessionTypeEnum.valueOf(value);
      } catch {
         return SessionTypeEnum.UNKNOWN;
      }
   }
}
